/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React, {useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";

import {useOnClickOutside} from "helpers";

import CheckboxDropdown from "./CheckboxDropdown";

const propTypes = {
  formData: PropTypes.object.isRequired,
  isUpdatingAnswer: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  question: PropTypes.any.isRequired,
  setFormData: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

const CheckboxDropdownContainer = ({
  title,
  question,
  formData,
  isUpdatingAnswer,
  setFormData,
  options
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const dropdownRef = useRef();

  useOnClickOutside(dropdownRef, () => setShowDropdown(false));

  useEffect(() => {
    handleFormUpdate();
    selectedItemsLabel();
  }, [selectedValues]);

  useEffect(() => {
    handleAlreadySelectedValues();
  }, [isUpdatingAnswer, title, options]);


  const selectedItemsLabel = () => {
    const labels = selectedValues.map(value => {
      const matchingOption = options.find(option => option.value === value);
      return matchingOption ? matchingOption.label : "";
    });
    return labels.join(", ");
  };

  const handleAlreadySelectedValues = () => {
    if (isUpdatingAnswer && Array.isArray(title)) {
      const newSelectedValues = title.reduce((acc, arrayItem) => {
        const matchingOption = options.find(option => option.label === arrayItem);
        if (matchingOption) {
          acc.push(matchingOption.value);
        }
        return acc;
      }, []);

      setSelectedValues(newSelectedValues);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedValues((prevSelectedValues) => {
      if (prevSelectedValues.includes(value)) {
        return prevSelectedValues.filter((v) => v !== value);
      } else {
        return [...prevSelectedValues, value];
      }
    });
    setShowDropdown(true);
  };

  const handleFormUpdate = () => {
    setFormData({
      ...formData,
      [question.externalId]: {
        answer: selectedValues,
        qnaStage: question.externalId
      }
    });
  };

  const handleOptionClick = (value, event) => {
    event.stopPropagation();
    handleCheckboxChange(value);
  };
  return (
    <CheckboxDropdown
      dropdownRef={dropdownRef}
      handleOptionClick={handleOptionClick}
      options={options}
      selectedItemsLabel={selectedItemsLabel}
      selectedValues={selectedValues}
      setShowDropdown={setShowDropdown}
      showDropdown={showDropdown}
      title={title}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

CheckboxDropdownContainer.propTypes = propTypes;

export default CheckboxDropdownContainer;
